'use strict';

var GridMaximizeConstants = {
  GRID_KEY_TO_MAXIMIZE_FLAG_MAPPING: {
    'cabin-flight-analysis': 'isFlightCabinAnalysisGridExpanded',
    'class-flight-analysis': 'isFlightClassAnalysisGridExpanded',
    'service-flight-analysis': 'isFlightServiceAnalysisGridExpanded',
    'cabin-flight-analysis-post-departure': 'isFlightCabinPostDepartureAnalysisGridExpanded',
    'class-flight-analysis-post-departure': 'isFlightClassPostDepartureAnalysisGridExpanded',
    'segment-flight-analysis-post-departure': 'isFlightSegmentPostDepartureAnalysisGridExpanded',
    'service-flight-analysis-post-departure': 'isFlightServiceAnalysisPostDepartureGridExpanded'
  },
  GRID_KEY_TO_WORKFLOW_SETTING_MAPPING: {
    'cabin-flight-analysis': 'flightAnalysisCabinGridExpansion',
    'class-flight-analysis': 'flightAnalysisClassGridExpansion',
    'service-flight-analysis': 'flightAnalysisServiceGridExpansion',
    'cabin-flight-analysis-post-departure': 'flightAnalysisPostDeptSegCabinGridExpansion',
    'class-flight-analysis-post-departure': 'flightAnalysisPostDeptClassGridExpansion',
    'segment-flight-analysis-post-departure': 'flightAnalysisPostDeptSegClassGridExpansion',
    'service-flight-analysis-post-departure': 'flightAnalysisPostDeptServiceGridExpansion'
  },
  MODE_INDEX_MAP: {
    'market': 1,
    'market-product-group': 2,
    'service': 3
  },
  FLIGHT_SCREEN: 'FLIGHT_SCREEN',
  MARKET_TAB: 'MARKET_SCREEN_market',
  MARKET_PRODUCT_TAB: 'MARKET_SCREEN_market-product-group',
  SERVICE_TAB: 'MARKET_SCREEN_service',
  FLIGHT_ANALYSIS_TABS: 'FLIGHT_SCREEN_cabin'
};
module.exports = GridMaximizeConstants;